'use strict';

import _firebase from './_firebase.js';
import axios from 'axios';

const address = "https://rosepetal-orchestrator-685118579523.us-central1.run.app" //"https://jupyter.rosepetal.ai/vlm";

const vlm = {
	/**
	 * Sends a predict request to the VLM service.
	 *
	 * @param {string} model_uri - The model to use.
	 * @param {string} prompt - A prompt string to influence the prediction.
	 * @param {string} image_uri - The URI of the image to be processed.
	 * @param {string} projectId - The project ID for Firebase.
	 * @returns {Promise<any>} - The response data from the VLM service.
	 */
	predict: async function (model_uri, prompt, image_uri, projectId) {
		const token = _firebase.auth.currentUser.accessToken;
		const accesToken = 'Bearer ' + token;
		try {
			const response = await axios.post(
				`${address}/inference/florence2/`,
				{ model_uri, prompt, image_uri },
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			return response.data;
		} catch (error) {
			console.error("Error fetching predictions:", error);
			throw error;
		}
	},
	/**
	 * Sends an image to the VLM service.
	 *
	 * @param {string} image_uri - The image to cache.
	 * @param {string} projectId - The project ID for Firebase.
	 * @returns {Promise<any>} - The response data from the VLM service.
	 */
	setImage: async function (image_uri, projectId) {
		const token = _firebase.auth.currentUser.accessToken;
		const accesToken = 'Bearer ' + token;
		try {
			const response = await axios.post(
				`${address}/inference/florence2/`,
				{ image_uri },
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			return response.data;
		} catch (error) {
			console.error("Error fetching result:", error);
			throw error;
		}
	},
	/**
	 * 
	 * @param {string} projectId 
	 * @returns {Promise<any>} - The response data from the VLM service.
	 */
	checkFlorence2health: async function (projectId) {
		const token = _firebase.auth.currentUser.accessToken;
		const accesToken = 'Bearer ' + token;
		try {
			console.log("Checking Florence2 health...");
			const response = await axios.get(
				`${address}/service/florence2/`,
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			console.log("Florence2 health check response:", response);
			return response.data;
		} catch (error) {
			console.error("Error fetching result:", error);
			throw error;
		}
	},
	/**
	 * 
	 * @param {string} projectId 
	 * @returns {Promise<any>} - The response data from the VLM service.
	 */
	checkOrchestratorHealth: async function (projectId) {
		const token = _firebase.auth.currentUser.accessToken;
		const accesToken = 'Bearer ' + token;
		try {
			console.log("Checking orchestrator health...");
			const response = await axios.get(
				`${address}/health/`,
				{
					responseType: 'json',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': accesToken,
						"Firebase-Project-ID": projectId
					}
				}
			);
			console.log("Orchestrator health check response:", response);
			return response.data;
		} catch (error) {
			console.error("Error fetching result:", error);
			throw error;
		}
	}

};

export default vlm;
